import React from 'react';
import PackageFeatureItem from './PackageFeatureItem';

const PackageFeatures = ({ features }) => {
    if (!features)
        return null;
    return (
        <div className="package-features">
            <span className="em includes">Incluye:</span>
            <ul className="list-item">
            {
                features.map((feature, index) => {
                    return <PackageFeatureItem key={index} feature={feature} />;
                })
            }
            </ul>
        </div>
    );
}

export default PackageFeatures;